module.exports = __webpack_public_path__ + "static/media/Bettkissen_80x80.0e529c72.png";